export enum uniqueTextEnum {
  string = 'string',
  text = 'text',
  textarea = 'textarea',
  labelContato = 'Contato:',
  nameContato = 'Contato',
  labelNomeDoContato = 'Nome do contato',
  nameContactName = 'contactName',
  labelDadosDeContato = 'Dados de contato',
  nameContactData = 'contactData',
  labelTituloLista = 'Título da Lista',
  nameHeadline = 'headline',
}

type HeadlessDeliveryObjectType = {
  contentFieldValue: {
    data?: string;
  };
  dataType: string;
  inputControl?: string;
  label: string;
  name: string;
  nestedContentFields: HeadlessDeliveryObjectType[];
  repeatable: boolean;
};

let CONTENT_FIELD: HeadlessDeliveryObjectType[] = [
  {
    contentFieldValue: {
      data: 'Telefones da Central Smiles',
    },
    dataType: uniqueTextEnum.string,
    inputControl: uniqueTextEnum.text,
    label: uniqueTextEnum.labelTituloLista,
    name: uniqueTextEnum.nameHeadline,
    nestedContentFields: [],
    repeatable: false,
  },
  {
    contentFieldValue: {
      data: '',
    },
    dataType: uniqueTextEnum.string,
    inputControl: uniqueTextEnum.textarea,
    label: 'Descrição ou Comentário',
    name: 'description',
    nestedContentFields: [],
    repeatable: false,
  },
];

const MAP_CARDS: HeadlessDeliveryObjectType[] = [
  {
    category: 'Smiles e Prata',
    contact: 'Telefone: 0300 115 7001\nHorário de atendimento: 06h - 00h',
  },
  {
    category: 'Diamante e Ouro',
    contact: 'Telefone: 0300 115 7007\nHorário de atendimento: 24h',
  },
  {
    category: 'Deficientes Auditivos',
    contact: 'Telefone: 0300 709 0466\nHorário de atendimento: 24h',
  },
].map((v) => {
  return {
    contentFieldValue: {},
    dataType: '',
    label: uniqueTextEnum.labelContato,
    name: uniqueTextEnum.nameContato,
    nestedContentFields: [
      {
        contentFieldValue: {
          data: v.category,
        },
        dataType: uniqueTextEnum.string,
        inputControl: uniqueTextEnum.text,
        label: uniqueTextEnum.labelNomeDoContato,
        name: uniqueTextEnum.nameContactName,
        nestedContentFields: [],
        repeatable: false,
      },
      {
        contentFieldValue: {
          data: v.contact,
        },
        dataType: uniqueTextEnum.string,
        inputControl: uniqueTextEnum.textarea,
        label: uniqueTextEnum.labelDadosDeContato,
        name: uniqueTextEnum.nameContactData,
        nestedContentFields: [],
        repeatable: false,
      },
    ],
    repeatable: true,
  };
});

CONTENT_FIELD = CONTENT_FIELD.concat(MAP_CARDS);

export const TELEFONES_CENTRAL = {
  actions: {
    get: {
      method: 'GET',
      href: 'https://api-cms-portal-uat4.smiles.com.br/o/headless-delivery/v1.0/sites/{siteId}/structured-contents',
    },
  },
  facets: [],
  items: [
    {
      actions: {
        'get-rendered-content': {
          method: 'GET',
          href: 'https://api-cms-portal-uat4.smiles.com.br/o/headless-delivery/v1.0/structured-contents/{structuredContentId}/rendered-content/{contentTemplateId}',
        },
        get: {
          method: 'GET',
          href: 'https://api-cms-portal-uat4.smiles.com.br/o/headless-delivery/v1.0/structured-contents/{structuredContentId}',
        },
      },
      availableLanguages: ['pt-BR'],
      contentFields: CONTENT_FIELD,
      contentStructureId: 45013,
      creator: {
        additionalName: '',
        contentType: 'UserAccount',
        familyName: 'Smiles',
        givenName: 'Administrador',
        id: 20130,
        name: 'Administrador Smiles',
      },
      customFields: [],
      dateCreated: '2020-12-09T12:40:09Z',
      dateModified: '2020-12-09T12:40:09Z',
      datePublished: '2020-12-09T12:35:00Z',
      description: '',
      friendlyUrlPath: 'telefones_central',
      id: 47604,
      key: '825748',
      keywords: [],
      numberOfComments: 0,
      relatedContents: [],
      renderedContents: [],
      siteId: 20124,
      subscribed: false,
      taxonomyCategoryBriefs: [],
      title: 'telefones_central',
      uuid: 'e1d306cf-c52f-927d-a6dc-bce224792c5f',
    },
  ],
  lastPage: 1,
  page: 1,
  pageSize: 20,
  totalCount: 1,
};

export const TELEFONES_CENTRAL_FIELDS = {
  actions: {
    get: {
      method: 'GET',
      href: 'https://api-cms-portal-uat5.smiles.com.br/o/headless-delivery/v1.0/sites/{siteId}/structured-contents',
    },
  },
  facets: [],
  items: [
    {
      contentFields: [
        {
          contentFieldValue: {
            data: 'Telefones da Central Smiles',
          },
          name: 'headline',
        },
        {
          contentFieldValue: {
            data: '',
          },
          name: 'description',
        },
        {
          contentFieldValue: {},
          name: 'Contato',
        },
        {
          contentFieldValue: {},
          name: 'Contato',
        },
        {
          contentFieldValue: {},
          name: 'Contato',
        },
      ],
      friendlyUrlPath: 'telefones_central',
    },
  ],
  lastPage: 1,
  page: 1,
  pageSize: 20,
  totalCount: 1,
};

export default {
  uniqueTextEnum,
  TELEFONES_CENTRAL,
  TELEFONES_CENTRAL_FIELDS,
};
